import ScrollableContainer from './ScrollableContainer';

export default ScrollableContainer;
